export default __webpack_public_path__ + "static/media/BS.be1ac2ed.svg";